import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BoschUiStepIndicatorComponent } from './bosch-ui-step-indicator.component';
import { BoschUiStepIndicatorStepComponent } from './bosch-ui-step-indicator-step/bosch-ui-step-indicator-step.component';
import { BoschUiIconComponent } from '../../atoms/bosch-ui-icon/bosch-ui-icon.component';

@NgModule({
  imports: [CommonModule, BoschUiIconComponent],
  declarations: [BoschUiStepIndicatorComponent, BoschUiStepIndicatorStepComponent],
  exports: [BoschUiStepIndicatorComponent, BoschUiStepIndicatorStepComponent],
})
export class BoschUiStepIndicatorModule {}
